/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RepliesInputs */

const en_replies = /** @type {(inputs: RepliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replies`)
};

const id_replies = /** @type {(inputs: RepliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balasan`)
};

/** @type {(inputs: RepliesInputs) => LocalizedString} */
const es_replies = en_replies;

/** @type {(inputs: RepliesInputs) => LocalizedString} */
const fr_replies = en_replies;

/** @type {(inputs: RepliesInputs) => LocalizedString} */
const de_replies = en_replies;

/** @type {(inputs: RepliesInputs) => LocalizedString} */
const ja_replies = en_replies;

/** @type {(inputs: RepliesInputs) => LocalizedString} */
const zh_replies = en_replies;

/** @type {(inputs: RepliesInputs) => LocalizedString} */
const ar_replies = en_replies;

/** @type {(inputs: RepliesInputs) => LocalizedString} */
const it_replies = en_replies;

/** @type {(inputs: RepliesInputs) => LocalizedString} */
const ru_replies = en_replies;

/** @type {(inputs: RepliesInputs) => LocalizedString} */
const pt_replies = en_replies;

/** @type {(inputs: RepliesInputs) => LocalizedString} */
const ko_replies = en_replies;

/**
* | output |
* | --- |
* | "Replies" |
*
* @param {RepliesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const replies = /** @type {((inputs?: RepliesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RepliesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_replies(inputs)
	if (locale === "es") return es_replies(inputs)
	if (locale === "fr") return fr_replies(inputs)
	if (locale === "de") return de_replies(inputs)
	if (locale === "ja") return ja_replies(inputs)
	if (locale === "zh") return zh_replies(inputs)
	if (locale === "ar") return ar_replies(inputs)
	if (locale === "id") return id_replies(inputs)
	if (locale === "it") return it_replies(inputs)
	if (locale === "ru") return ru_replies(inputs)
	if (locale === "pt") return pt_replies(inputs)
	return ko_replies(inputs)
});